import React from 'react';
import { ListContentTemplate } from 'themes/components';

function ListContent(props) {
    return <ListContentTemplate {...props} />
}

export default ListContent;